module.exports = __webpack_public_path__ + "static/media/PARIS_Front-End_User_Guide.89d9742e.pdf";